export const DISPLAY_ALERT = 'DISPLAY_ALERT';
export const CLOSE_ALERT = 'CLOSE_ALERT';
